export const currency = (value: number | null | undefined, defaultValue?: string): string =>
  value !== null && value !== undefined
    ? `${value.toLocaleString('de-AT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
    : defaultValue
      ? defaultValue
      : '';
